import { PureAbility } from '@casl/ability';

import { CustomRoles } from './Session';

export type Entities =
  | 'Home'
  | 'Proxy'
  | 'User'
  | 'Stellar'
  | 'Footer'
  | 'Cheershub'
  | 'Employee'
  | 'Administration'
  | 'CommonMenus';

export const Action = {
  Create: 'create',
  Edit: 'edit',
  View: 'view',
  List: 'list',
  Manage: 'manage',
  Vote: 'vote',
  Facilitate: 'facilitate',
  Proxy: 'proxy',
  StopProxy: 'stopProxy',
  Unlock: 'unlock',
  Skip: 'skip',
  Delete: 'delete',
  Download: 'download'
} as const;

export type Action = (typeof Action)[keyof typeof Action];

export type AbilityTuple = [`${Action}`, Entities | Record<string, unknown>];

export type AppAbility = PureAbility<AbilityTuple>;

export type UserForAbility =
  | {
      proxiedAs?: {
        isGlobalAdmin?: boolean | null;
        isEligible?: boolean | null;
      } | null;
      roles?: CustomRoles[] | null;
      isGlobalAdmin?: boolean;
      isEligible?: boolean;
    }
  | null
  | undefined;
